import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const DeepDiveLogo = () => {
  return <StaticImage width={230} src="../images/deepdive-logo.png" alt="DeepDive 360" />;
};

export default DeepDiveLogo;
